import React, { useState } from "react";
import {
    useDeleteDepartmentUserMapping,
    useGetDepartmentUserMappings
} from "../../../../backend/masters";
import { useExportUserDepartments } from "../../../../backend/exports";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TOOLTIP_DELAY } from "../../../common/Constants";
import { UI_DELIMITER } from "../../../../utils/constants";
import DepartmentUserDetails from "./DepartmentUserDetails";
import AddEditDepartmentUser from "./AddEditDepartmentUser"
import { CellTmpl, reactFormatter } from "../../../common/Table";
import BaseList from '../../../common/BaseList';
import { DepartmentSchema } from '../../../../models/department';

const SortFields: any = {
    user: 'user_name'
}

const initialPayload: any = {
  sorts: ['user_name asc'],
  includes: {
    user: ['roles'],
    department: { vertical: ['company'] }
  },
  include: {
    user: { include: ['roles'] },
    department: {
      include: { 
        vertical: {
          include:  ['company']
        }
      }
    }
  }
}

function MangeDepartmentUsers() {
    const [breadcrumb] = useState([
        { id: 'home', label: 'Home', path: '/' },
        { id: 'users', label: 'User Management', path: '/userManagement/roles' },
        { id: 'department-user', label: 'Department User Mapping' },
    ]);

    function RoleTmpl({ cell }: any) {
        const { user } = cell.getData();
        const roles = (user && user.roles || []).map(({ name }: any) => name);
        const userRole = roles.join(UI_DELIMITER);
        return (
            <>
                {
                    !!userRole &&
                    <div className="d-flex align-items-center h-100 w-auto">
                        <OverlayTrigger overlay={<Tooltip>{userRole}</Tooltip>} rootClose={true}
                            placement="bottom" delay={{ show: TOOLTIP_DELAY } as any}>
                            <div className="ellipse two-lines">{userRole}</div>
                        </OverlayTrigger>
                    </div>
                }
            </>
        )
    }

    function ValueTmpl({ cell }: any) {
        const row = cell.getData();
        const _def = cell.getColumn().getDefinition();
        const value = (row[_def.field] || {}).name;
        return (
            <>
                {
                    !!value &&
                    <div className="d-flex align-items-center h-100 w-auto">
                        <OverlayTrigger overlay={<Tooltip>{value}</Tooltip>} rootClose={true}
                            placement="bottom" delay={{ show: TOOLTIP_DELAY } as any}>
                            <div className="ellipse two-lines">{value}</div>
                        </OverlayTrigger>
                    </div>
                }
            </>
        )
    }

    function DepartmentTmpl({ cell }: any) {
        const row = cell.getData();
        const value = (row.department || {}).name;
        return (
            <>
                {
                    !!value &&
                    <div className="d-flex align-items-center h-100 w-auto">
                        <OverlayTrigger overlay={<Tooltip>{value}</Tooltip>} rootClose={true}
                            placement="bottom" delay={{ show: TOOLTIP_DELAY } as any}>
                            <div className="ellipse two-lines">{value}</div>
                        </OverlayTrigger>
                    </div>
                }
            </>
        )
    }

    function UserTmpl({ cell }: any) {
        const row = cell.getData();
        const value = (row.user || {}).name;
        return (
            <>
                {
                    !!value &&
                    <div className="d-flex align-items-center h-100 w-auto">
                        <OverlayTrigger overlay={<Tooltip>{value}</Tooltip>} rootClose={true}
                            placement="bottom" delay={{ show: TOOLTIP_DELAY } as any}>
                            <div className="ellipse two-lines">{value}</div>
                        </OverlayTrigger>
                    </div>
                }
            </>
        )
    }

    function CompanyTmpl({ cell }: any) {
        const row = cell.getData();
        const value = (((row.department || {}).vertical || {}).company || {}).name;
        return (
            <>
                {
                    !!value &&
                    <div className="d-flex align-items-center h-100 w-auto">
                        <OverlayTrigger overlay={<Tooltip>{value}</Tooltip>} rootClose={true}
                            placement="bottom" delay={{ show: TOOLTIP_DELAY } as any}>
                            <div className="ellipse two-lines">{value}</div>
                        </OverlayTrigger>
                    </div>
                }
            </>
        )
    }

    function VerticalTmpl({ cell }: any) {
        const row = cell.getData();
        const value = ((row.department || {}).vertical || {}).name;
        return (
            <>
                {
                    !!value &&
                    <div className="d-flex align-items-center h-100 w-auto">
                        <OverlayTrigger overlay={<Tooltip>{value}</Tooltip>} rootClose={true}
                            placement="bottom" delay={{ show: TOOLTIP_DELAY } as any}>
                            <div className="ellipse two-lines">{value}</div>
                        </OverlayTrigger>
                    </div>
                }
            </>
        )
    }

    const columns = [
        { title: "Company", field: "department_vertical_company_name", formatter: reactFormatter(<CompanyTmpl />) },
        { title: "Vertical", field: "department_vertical_name", formatter: reactFormatter(<VerticalTmpl />) },
        { title: "Department", field: "department_name", formatter: reactFormatter(<DepartmentTmpl />) },
        { title: "User", field: "user_name", formatter: reactFormatter(<UserTmpl />) },
        { title: "User Role", field: "user_roles", formatter: reactFormatter(<RoleTmpl />), headerSort: false, },
    ]
    const searchConfig = {
        name: 'department_name',
        label: 'Department'
    }
    return (
      <BaseList
        fetchData={useGetDepartmentUserMappings}
        deleteData={useDeleteDepartmentUserMapping}
        nameAttribute={'name'}
        columns={columns}
        DetailView={DepartmentUserDetails}
        FormView={AddEditDepartmentUser}
        modelSchema={DepartmentSchema}
        initialPayload={initialPayload}
        initialSort={['name asc']}
        breadcrumb={breadcrumb}
        searchConfig={searchConfig}
        exportData={useExportUserDepartments}
        title="Department User Mapping"
      />
    )
}

export default MangeDepartmentUsers;
